import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            核心优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            为什么数百万用户选择无极电影网
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-100 rounded-xl border border-background-200/60 p-6 md:p-8 text-center hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100/80 text-primary-600 mx-auto text-2xl md:text-3xl">
                <i className={feature.icon}></i>
              </span>
              <h3 className="mt-5 md:mt-6 text-lg md:text-xl font-heading font-bold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}